import { render, staticRenderFns } from "./SoiDownloadsIndicator.vue?vue&type=template&id=5ab909b5&"
import script from "./SoiDownloadsIndicator.vue?vue&type=script&lang=js&"
export * from "./SoiDownloadsIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports